// WhatsApp-Gruppen Konfiguration
// FGP WhatsApp Community Links

export const WHATSAPP_LINKS = {
  rider: {
    url: 'https://chat.whatsapp.com/G8Pjr1b2iri45rPhjnmDiW?mode=wwc',
    name: 'FGP Club'
  },
  trainer: {
    url: 'https://chat.whatsapp.com/EOQoiMJFuXL00xaSiH3xdT?mode=wwc',
    name: 'FGP Trainer/Therapeuten'
  }
};

export default WHATSAPP_LINKS;
